<!-- 期望的修改结果，业务类型修改为输入下拉多选；多表单合并 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="label-top">
      <!-- 新增根节点按钮 -->
      <el-button type="primary"
                 class="label-button"
                 @click="addParent">{{ $t('add') }}</el-button>
      <div class="all-class">
        <div class="open-class"
             @click="openAll">展开所有</div>
        <div class="close-class"
             @click="closeAll">关闭所有</div>
        <el-checkbox-group v-model="checkedOptions"
                           class="check-class"
                           :min="1"
                           @change="handleCheckAll">
          <el-checkbox v-for="option in options"
                       :label="option"
                       :key="option">{{option}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 标签列表树 -->
    <el-tree class="label-tree"
             ref="labelTree"
             :data="data"
             default-expand-all
             :props="defaultProps"
             @node-click="handleNodeClick"
             @node-expand="expandClick"
             @node-collapse="collapseClick"
             :filter-node-method="filterNode"
             :default-expanded-keys="idArr"
             node-key="labelId"
             :expand-on-click-node="false">
      <span class="custom-tree-node"
            slot-scope="{ node, data }">
        <span class="tree-label"
              :title='node.label'>{{ node.label }}</span>
        <span>
          <!-- labelFlag == '20'如果为标签则不显示新增按钮 -->
          <em class="el-icon-plus ipl"
             v-if="data.labelFlag == '20'"
             @click="add(data)"></em>
          <em class="el-icon-edit ipl"
             @click="update(data)"></em>
          <!-- <em class="el-icon-delete ipl" @click.stop="isDelete(data)"></em> -->
        </span>
      </span>
    </el-tree>
    <!-- 标签表单 -->
    <el-form style="border-left: 1px rgb(234, 233, 233) solid"
             :rules="dataRule"
             :model="dataForm"
             ref="dataForm"
             label-width="130px">
      <el-row>
        <el-col :span="12"
                class="mar-b">
          <!-- 标签名称 -->
          <el-form-item :label="$t('label.labelName')"
                        prop="labelName"
                        style="width:100% !important">
            <el-input class="fl"
                      v-model="dataForm.labelName"
                      :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
                class="mar-b">
          <!-- 新增根节点无法修改是否标签，修改根节点无法修改是否标签 -->
          <!-- 是否为标签 10：是，20：否 -->
          <el-form-item :label="$t('label.labelFlag')">
            <el-switch v-model="dataForm.labelFlag"
                       :disabled="isDisabled || labelFlagAble"
                       :inactive-text="$t('running.suspended0')"
                       inactive-value="20"
                       :active-text="$t('running.suspended1')"
                       active-value="10"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="dataForm.labelFlag == '20'">
        <!-- 业务类型 labelFlag === '20' 不为标签才显示业务类型选项-->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('label.masterData')"
                        prop="masterDataIdList">
            <el-select v-model="dataForm.masterDataIdList"
                       multiple
                       collapse-tags
                       filterable
                       :disabled="isDisabled">
              <el-option v-for="item in bussinessList"
                         :key="item.bussinessTypeCode"
                         :label="item.bussinessTypeName"
                         :value="item.bussinessTypeId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
                class="mar-b">
          <!-- 是否显示 10：是，20：否 -->
          <el-form-item :label="$t('label.showFlag')">
            <el-switch v-model="dataForm.showFlag"
                       :inactive-text="$t('running.labelSuspended0')"
                       inactive-value="20"
                       :active-text="$t('running.labelSuspended1')"
                       active-value="10"
                       :disabled="isDisabled"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div style="margin: 10px 0px 20px 50px;"
             v-show="saveButtonShow">
          <el-button type="primary"
                     @click="saveClick">{{ $t('user.save') }}</el-button>
        </div>
      </el-row>
    </el-form>
  </el-card>
</template>

<script type="text/javascript">
import { treeDataTranslate } from '@/utils'
import debounce from 'lodash/debounce'
export default {
  data() {
    return {
      checkedOptions: ['活动'],
      options: ['活动', '不活动'],
      labelFlagAble: true, // 新增根节点默认为否且不可修改，修改有下级的非标签、不能修改
      data: [],
      idArr: [],
      defaultProps: {
        children: 'children',
        label: 'labelName',
        id: 'labelId'
      },
      // 业务类型下拉框
      bussinessList: [],
      dataForm: {
        parentLabelId: 0, // 上级标签id
        showFlag: '20', // 是否显示
        labelFlag: '20', // 是否标签
        masterDataIdList: [] // 业务类型列表
      },
      // 是否禁用：默认是
      isDisabled: true,
      // 保存按钮是否显示：默认否
      saveButtonShow: false,
      // 阻止冒泡事件
      stopPre: false,
      // 默认活动
      filterText: '10'
    }
  },
  created() {
    // 获取左侧标签树
    this.getDataListView()
    // 获取业务类型下拉框
    this.getTreeList()
  },
  computed: {
    dataRule() {
      return {
        labelName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 40, message: this.$t('validate.validateLength', { 'handle': '40' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    // 活动 不活动
    filterText(val) {
      this.$refs.labelTree.filter(val)
    }
  },
  methods: {
    getTreeActive() {
      this.$nextTick(() => {
        this.$refs.labelTree.filter(this.filterText)
      })
    },
    handleCheckAll(val) {
      if (val.length === 1 && val[0] === '活动') {
        this.filterText = '10'
      } else if (val.length === 1 && val[0] === '不活动') {
        this.filterText = '20'
      } else if (val.length === 2) {
        this.filterText = ''
      }
    },
    // 筛选
    filterNode(value, data) {
      if (!value) return true
      return data.showFlag.indexOf(value) !== -1
    },
    // 展开所有
    openAll() {
      this.$nextTick(() => {
        for (var i = 0; i < this.$refs.labelTree.store._getAllNodes().length; i++) {
          this.$refs.labelTree.store._getAllNodes()[i].expanded = true
        }
      })
    },
    // 收起所有
    closeAll() {
      this.$nextTick(() => {
        for (var i = 0; i < this.$refs.labelTree.store._getAllNodes().length; i++) {
          this.$refs.labelTree.store._getAllNodes()[i].expanded = false
        }
      })
    },
    // 展开节点
    expandClick(data, node, templateNode) {
      this.idArr.push(data.labelId)
    },
    // 关闭节点
    collapseClick(data, node, templateNode) {
      for (let i = 0; i < this.idArr.length; i++) {
        if (data.labelId === this.idArr[i]) {
          this.idArr.splice(i)
        }
      }
    },
    // 获取每个子节点
    getTreeList() {
      this.$request.get(
        '/sys/commlabel/labelList'
      ).then((res, total, code, data) => {
        this.data = treeDataTranslate(
          res,
          'labelId',
          'parentLabelId'
        )
        this.getTreeActive()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取业务类型下拉框
    getDataListView() {
      this.$request.get(
        '/sys/commlabel/bussinessList'
      ).then((res, total, code, data) => {
        this.bussinessList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    // 点击获取每个treelist值的详细信息
    handleNodeClick(data, node, templateNode) {
      let nodeData = data
      if (this.stopPre) {
        this.stopPre = false
        return false
      }
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate('labelName')
      }
      this.isDisabled = true
      this.saveButtonShow = false
      this.$request.get(
        `/sys/commlabel/info/${nodeData.labelId}`
      ).then((res, total, code, data) => {
        this.dataForm = res
        this.$request.get(
          `/sys/commlabel/bussinessInfo/${nodeData.labelId}`
        ).then((res, total, code, data) => {
          let returnList = []
          for (let i = 0; i < res.length; i++) {
            returnList.push(res[i].bussinessTypeId)
          }
          this.dataForm.masterDataIdList = returnList
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 点击新增根节点
    addParent() {
      this.labelFlagAble = false
      this.saveButtonShow = true
      this.isDisabled = false
      this.dataForm = {
        parentLabelId: 0,
        labelName: '',
        showFlag: '10',
        labelFlag: '20',
        masterDataIdList: [],
        fullLabelIds: '0,'
      }
    },
    // 点击新增
    add(data) {
      this.stopPre = true
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate('labelName')
      }
      this.idArr.push(data.labelId)
      this.labelFlagAble = false
      this.isDisabled = false
      this.saveButtonShow = true
      this.dataForm = {
        parentLabelId: data.labelId,
        labelName: '',
        showFlag: '10',
        labelFlag: '10',
        masterDataIdList: [],
        fullLabelIds: data.fullLabelIds
      }
    },
    // 点击修改
    update(data) {
      let nodeData = data
      this.stopPre = true
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate('labelName')
      }
      if (data.children) {
        this.labelFlagAble = true
      } else {
        this.labelFlagAble = false
      }
      this.saveButtonShow = true
      this.isDisabled = false
      this.$request.get(
        `/sys/commlabel/info/${nodeData.labelId}`
      ).then((res, total, code, data) => {
        this.dataForm = res
        this.$request.get(
          `/sys/commlabel/bussinessInfo/${nodeData.labelId}`
        ).then((res, total, code, data) => {
          let returnList = []
          for (let i = 0; i < res.length; i++) {
            returnList.push(res[i].bussinessTypeId)
          }
          this.dataForm.masterDataIdList = returnList
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存
    saveClick: debounce(
      function () {
        let dataFormModify = { ...this.dataForm }
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          // 20 不是标签才可以选择业务类型
          if (this.dataForm.labelFlag === '20') {
          } else {
            this.dataForm.masterDataIdList = []
          }
          this.$request.post(
            `/sys/commlabel/${!dataFormModify.labelId ? 'save' : 'update'}`,
            this.dataForm
          ).then((res, total, code, data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.isDisabled = true
                this.updateShow = false
                this.dataForm = {}
                this.$request
                  .get(`/sys/commlabel/labelList`)
                  .then((res, total, code, data) => {
                    this.data = treeDataTranslate(
                      data.result,
                      'labelId',
                      'parentLabelId'
                    )
                  //修改添加标签，活动筛选bug
                  this.getTreeActive()
                  }).catch((err) => {
                    console.log(err)
                  })
              }
            })
          }).catch((err) => {
            console.log(err)
          })
        })
      }, 5000, { leading: true, trailing: false }
    )
    // 删除每个子节点
    // isDelete: debounce(
    //   function (data) {
    //     let deleteid = data.labelId
    //     this.$confirm(
    //       this.$t('prompt.info', { handle: this.$t('delete') }),
    //       this.$t('prompt.title'),
    //       {
    //         confirmButtonText: this.$t('confirm'),
    //         cancelButtonText: this.$t('cancel'),
    //         type: 'warning'
    //       }
    //     ).then(() => {
    //       this.$request.post(
    //         `/sys/commlabel/delete`,
    //         {
    //           deleteId: deleteid
    //         }
    //       ).then((res, total, code, data) => {
    //         this.$message({
    //           message: this.$t('prompt.success'),
    //           type: 'success',
    //           duration: 500,
    //           onClose: () => {
    //             this.dataForm = {}
    //             this.$request.get(
    //               `/sys/commlabel/labelList`
    //             ).then((res, total, code, data) => {
    //               this.data = treeDataTranslate(
    //                 data.result,
    //                 'labelId',
    //                 'parentLabelId'
    //               )
    //             }).catch(() => {})
    //           }
    //         })
    //       }).catch(() => {})
    //     }).catch(() => {})
    //   }, 5000, { leading: true, trailing: false }
    // )
  }
}
</script>

<style lang="scss" scoped>
.label-tree {
  width: 30%;
  float: left;
  margin-bottom: 30px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  overflow: hidden;
}
.el-tree-node__content {
  .el-tree-node__expand-icon {
    z-index: 9;
  }
}
.ipl {
  margin-left: 5px;
  padding: 2px;
  border: 1px #ffffff solid;
}
.ipl:hover {
  background-color: #fff;
  color: #1c69d3;
  border: 1px #1c69d3 solid;
}
.el-form {
  width: 70%;
  float: right;
}
.el-form-item {
  text-align: left;
  width: 100% !important;
}
.el-input {
  max-width: 260px !important;
}
.mar-b {
  margin-bottom: 20px;
}
.tree-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-switch {
  float: left;
  margin: 4px;
}
.label-top {
  width: 100%;
  height: 70px;
  .label-button {
    margin-left: 20px;
  }
  .all-class {
    margin: 13px 22px;
    .open-class {
      margin-right: 20px;
      display: inline;
      color: #3177d7;
      cursor: pointer;
    }
    .close-class {
      margin-right: 20px;
      display: inline;
      color: #3177d7;
      cursor: pointer;
    }
    .check-class {
      display: inline;
      .el-checkbox {
        margin-right: 20px;
      }
    }
  }
}
</style>
